<template>
    <svg :cssClass="cssClass" :class="iconCssClass"  viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5312 0.223995L19.7797 9.5573C20.0734 9.85611 20.0734 10.3393 19.7797 10.6381L18.5424 11.897C18.2487 12.1958 17.7738 12.1958 17.4801 11.897L10 4.36294L2.51992 11.897C2.22621 12.1958 1.75129 12.1958 1.45758 11.897L0.220278 10.6381C-0.0734272 10.3393 -0.0734272 9.85611 0.220278 9.5573L9.46883 0.223995C9.76254 -0.0748224 10.2375 -0.0748224 10.5312 0.223995Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {

	props: {
		cssClass: {
			type: String,
			default: () => '',
		},
    },

    computed: {

        iconCssClass()
        {
            return `icon-svg ${this.cssClass}`
        },

    },

}
</script>

<style lang="scss">

</style>
